import { Navigate } from 'react-router-dom';
import { observer } from '@react';
import { usePlatformRole } from '../hooks/usePlatformRole';

interface AdminRouteProps {
  children: React.ReactNode;
  fallback?: string;
}

export const AdminRoute = observer(({ children, fallback = '/notifications' }: AdminRouteProps) => {
  const { isAdmin, isLoading } = usePlatformRole();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
});
